import React from "react";
import {LucideChevronDown, LucideChevronRight} from "lucide-react";

export default function PluginSection(props: {
    plugin: string,
    grantedCount: number,
    totalCount: number,
    open: boolean,
    onToggleOpen: () => void,
    children: React.ReactNode
}) {
    return (
        <div className="rounded-md border border-neutral-700 overflow-hidden">
            <button
                onClick={props.onToggleOpen}
                className="w-full flex items-center gap-2 px-3 py-2 bg-neutral-800 hover:bg-neutral-700 transition-colors text-left">
                {props.open ? <LucideChevronDown size={18} className="flex-shrink-0 text-neutral-400"/>
                    : <LucideChevronRight size={18} className="flex-shrink-0 text-neutral-400"/>}
                <span className="font-semibold text-white truncate">{props.plugin}</span>
                <span className="ms-auto text-xs text-neutral-400 flex-shrink-0">
                    {props.grantedCount > 0 && <span className="text-green-400">{props.grantedCount}</span>}
                    {props.grantedCount > 0 && " / "}
                    {props.totalCount}
                </span>
            </button>
            {props.open && (
                <div className="p-2 space-y-1 bg-neutral-900/50">
                    {props.children}
                </div>
            )}
        </div>
    )
}
